export const criteriaFiltersUnAuthorized = ['mortgages', 'loans', 'savings'];
